var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richBig ql-container ql-snow",style:({ background: _vm.richTxtContant.bgColor, border: 'none' })},[_c('div',{staticClass:"richbox content ql-editor",domProps:{"innerHTML":_vm._s(_vm.richTxtContant.richTxt)}})])}
var staticRenderFns = []

export { render, staticRenderFns }